import React from "react";
import ListPage from "./components/ListPage";
import { ContentCard } from "./components/ui";
import { useContentModal } from "./components/ContentModal";
import { formatDate } from "./utils/time";

const UpdatesList = () => {
    // Updates open in a modal, in place — not a new page.
    const { openContent } = useContentModal();

    return (
        <ListPage
            eyebrow="Latest"
            title="Updates & Announcements"
            intro="Company news, product releases and announcements from across Dolluz Corp."
            endpoint="/api/Dolluzcorp/updates/list"
            empty={{
                icon: "📣",
                title: "No announcements right now",
                message: "There's nothing published at the moment. New announcements will show up here.",
                noun: "update",
                nounPlural: "updates",
            }}
            renderCard={(u) => (
                <ContentCard
                    key={u.update_id}
                    onOpen={() => openContent("update", u.update_id)}
                    kind="Update"
                    title={u.title}
                    teaser={u.subject}
                    meta={formatDate(u.updated_time || u.created_time)}
                />
            )}
        />
    );
};

export default UpdatesList;
